import type { TNotePriority } from 'volley-common/dist/services/products.service';
import { capitalFirst } from 'volley-common/dist/utils/string.utils';

export function formatPriorityName(opt: TNotePriority) {
	return capitalFirst(opt);
}
